export default {
    messages: {
        uk: {
            'Динаміка росту та зниження цін': 'Динаміка росту та зниження цін на авто',
            'щотижневий моніторинг цін': 'щотижневий моніторинг цін',
            'Назад': 'Назад',
            activeListingsStripPrefix: '{count} активних {announcements} з середньою ціною',
            'оголошення': 'оголошення | оголошення | оголошень',
        },
        ru: {
            'Динаміка росту та зниження цін': 'Динамика роста и снижение цен на авто',
            'щотижневий моніторинг цін': 'еженедельный мониторинг цен',
            'Назад': 'Обратно',
            activeListingsStripPrefix: '{count} активных {announcements} со средней ценой',
            'оголошення': 'объявление | объявления | объявлений',
        }
    }
}
